import { client, gql } from 'data-provider';

export const getErpOption = async (attribute: string): Promise<string | null> => {
  const query = gql`
    query ($query: String) {
      getOptions(query: $query)
    }
  `;

  const data = await client.request(query, { query: attribute });
  return (data.getOptions as string | null) ?? null;
};

export const setErpOption = async (attribute: string, value: string): Promise<void> => {
  const mutation = gql`
    mutation ($input: erpOptionsDto!) {
      createErpOptions(input: $input)
    }
  `;

  await client.request(mutation, {
    input: { data: [{ attribute, value }] },
  });
};
